/**
 * Pure utility functions for Boards that have NO Bryntum dependencies.
 * These can be safely imported without pulling in Bryntum.
 */

import type { NumberOptions } from "@procore/globalization-toolkit";
import { NumberFormatter } from "@procore/globalization-toolkit";

/**
 * Formats a number to a percentage string with the given locale.
 * @param number - The number to format (e.g., 0.5 for 50%)
 * @param locale - The locale for formatting (default: "en")
 * @returns The formatted percentage string
 */
export function formatNumberWithPercentage(number: number, locale: string = "en") {
   const numberOptions: NumberOptions = {
      locale: locale,
      percent: "standard",
   };

   const formatter = new NumberFormatter(numberOptions);
   return formatter.formatNumber(number);
}
